import { format } from "date-fns";

export const normalizeSupportTicketProductQuantity = (quantity: number): number =>
  Number.isFinite(quantity) && quantity >= 1 ? Math.floor(quantity) : 1;

export const formatSupportTicketProductMeta = (
  quantity: number,
  productionDate: Date | null,
  serialNumber: string | null,
): string => {
  const normalizedQuantity = normalizeSupportTicketProductQuantity(quantity);
  const parts = [`· ${normalizedQuantity} szt.`];
  if (productionDate) {
    parts.push(format(productionDate, "dd.MM.yyyy"));
  }
  if (serialNumber) {
    parts.push(serialNumber);
  }
  return parts.join(" ");
};

export const formatSupportTicketProductLabel = (
  productLabel: string,
  quantity: number,
  productionDate: Date | null,
  serialNumber: string | null,
): string => {
  return `${productLabel} ${formatSupportTicketProductMeta(quantity, productionDate, serialNumber)}`;
};

export function supportTicketProductionDateToday(): Date {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate());
}

export function normalizeSupportTicketProductionDate(value: Date | null): Date | null {
  if (!value) return null;
  const today = supportTicketProductionDateToday();
  const candidate = new Date(value.getFullYear(), value.getMonth(), value.getDate());
  if (candidate > today) return today;
  return candidate;
}
